// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IconButton-m_HOVbkv02iRx2NNMk1ZsQ {
  cursor: pointer;
  color: var(--pps-blue);
  display: block;
  margin: 0 .5rem;
  text-align: center;
  width: 5rem;
}

.IconButton-m_HOVbkv02iRx2NNMk1ZsQ span {
  font-size: 3rem;
}

.IconButton-m_jX8BGYCRVrXViTYLPmwM {
  color: var(--pies-lightgrey);
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./client/shared/genericComponents/IconButton/IconButton.m.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB","sourcesContent":[".iconButton {\n  cursor: pointer;\n  color: var(--pps-blue);\n  display: block;\n  margin: 0 .5rem;\n  text-align: center;\n  width: 5rem;\n}\n\n.iconButton span {\n  font-size: 3rem;\n}\n\n.disabled {\n  color: var(--pies-lightgrey);\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
export var iconButton = `IconButton-m_HOVbkv02iRx2NNMk1ZsQ`;
export var disabled = `IconButton-m_jX8BGYCRVrXViTYLPmwM`;
export default ___CSS_LOADER_EXPORT___;
